import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { usePresentation } from '../../contexts/PresentationContext';
import LoadingSpinner from './LoadingSpinner';

// sem perfil = qualquer autenticado | "operador" = operador+admin | "admin" = admin only
const HIERARQUIA = { admin: 4, operador: 3, auditor_hospital: 2, cliente: 1 };

// admin/operador precisam escolher Administração ou Apresentação antes de ver qualquer tela —
// pass `semGateApresentacao` só na própria rota /modo-exibicao, senão cai num loop de redirect.
// `bloqueiaEmApresentacao` fecha rotas administrativas (Usuários/Auditoria) por URL direta,
// não só escondendo o link da Sidebar — quem digita/cola a URL não deve conseguir entrar.
export default function PrivateRoute({ children, perfil, semGateApresentacao, bloqueiaEmApresentacao }) {
  const { user, loading } = useAuth();
  const presentation = usePresentation();

  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" replace />;

  if (perfil && HIERARQUIA[user.perfil] < HIERARQUIA[perfil]) {
    return <Navigate to="/dashboard" replace />;
  }

  const precisaEscolherModo =
    !semGateApresentacao && (user.perfil === 'admin' || user.perfil === 'operador') && !presentation.modoEscolhido;
  if (precisaEscolherModo) return <Navigate to="/modo-exibicao" replace />;

  if (bloqueiaEmApresentacao && presentation.apresentacaoAtiva) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
